import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { postTable } from '../../api/api';
import { showToast } from '../common/Toast';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await postTable('tables/messages', formData);
      showToast('Votre message a bien été envoyé. Nous vous répondrons rapidement.');
      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (err) {
      showToast('Une erreur est survenue lors de l\'envoi.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="page-header">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/">Accueil</Link> / Contact
          </div>
          <h1>Contactez l'AEII</h1>
          <p style={{ color: 'rgba(255,255,255,0.85)', maxWidth: '600px' }}>
            Une question sur nos publications, nos abonnements ou un partenariat de recherche ?
            Notre équipe vous répond.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container contact-grid">
          <div className="contact-info-card">
            <h3>Nos coordonnées</h3>
            <div className="contact-info-item">
              <i className="fa-solid fa-location-dot"></i>
              <span>Siège : Bonapriso, Douala - Cameroun</span>
            </div>
            <div className="contact-info-item">
              <i className="fa-solid fa-envelope"></i>
              <span>contact@aeii.online</span>
            </div>
            <div className="contact-info-item">
              <i className="fa-solid fa-phone"></i>
              <span>+237 679 267 502 / +237 692 406 812</span>
            </div>
            <div className="contact-info-item">
              <i className="fa-solid fa-clock"></i>
              <span>Lundi – Vendredi : 8h30 – 17h30 (GMT)</span>
            </div>
            <div className="footer-social" style={{ marginTop: '24px' }}>
              <a href="#"><i className="fa-brands fa-linkedin-in"></i></a>
              <a href="#"><i className="fa-brands fa-x-twitter"></i></a>
              <a href="#"><i className="fa-brands fa-facebook-f"></i></a>
            </div>
          </div>

          <div className="form-card" style={{ maxWidth: '100%', boxShadow: 'none' }}>
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Nom complet</label>
                  <input
                    type="text"
                    id="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="subject">Sujet</label>
                <input
                  type="text"
                  id="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>

              <button type="submit" className="btn btn-dark btn-block" disabled={loading}>
                {loading ? 'Envoi en cours...' : 'Envoyer le message'}
              </button>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;